var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.630957 11.9991H11.3687C11.5359 11.9991 11.6962 11.9327 11.8144 11.8144C11.9327 11.6962 11.9991 11.5359 11.9991 11.3687V0.629C11.9991 0.546232 11.9828 0.464278 11.951 0.387842C11.9193 0.311406 11.8727 0.241995 11.8141 0.183594L0.183594 11.8146C0.242235 11.8734 0.311976 11.92 0.388771 11.9517C0.465566 11.9834 0.547887 11.9995 0.630957 11.9991Z",
    fill: "#FF8900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.632378 3.04099e-06C0.549467 -0.000254474 0.467319 0.0158454 0.390639 0.0473811C0.313958 0.0789167 0.244252 0.125269 0.185511 0.183782C0.12677 0.242296 0.0801482 0.311822 0.0483154 0.388379C0.0164827 0.464937 6.40764e-05 0.547022 1.03821e-07 0.629934V11.3696C-4.74947e-05 11.4524 0.0162722 11.5345 0.0480227 11.611C0.0797732 11.6875 0.126329 11.757 0.185015 11.8155L11.8155 0.184528C11.7571 0.125923 11.6877 0.0794499 11.6112 0.0477814C11.5348 0.0161129 11.4528 -0.000124699 11.3701 3.04099e-06H0.632378Z",
    fill: "#FFA922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.c4a2e345d4ff7bc9e22f87773c3e9901.svg";
export { ForwardRef as ReactComponent };